import { render, staticRenderFns } from "./VerificationCompleted.vue?vue&type=template&id=b245510a&scoped=true&"
import script from "./VerificationCompleted.vue?vue&type=script&lang=js&"
export * from "./VerificationCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b245510a",
  null
  
)

export default component.exports